import React, { useCallback, useEffect } from 'react';
import { ManagedPopup } from 'js/components/common/Popup';
import { useOnClose } from 'js/components/common/PopupManager';
import { useTranslations } from 'js/hooks/i18n';
import style from './index.scss';
import Games from './Games';
import { useDeviceSelector, useUserSelector } from 'js/store/hooks';
import { path, pick } from 'ramda';

export const ANIMATION_DURATION = 600;

const popupClassNames = {
    inner: style.popupInner,
    close: style.closeBtn,
    header: style.header
};

export const ExpandedCategoryGamesPopup = ({
                                          gameCodes,
                                          cid,
                                          displayName,
                                          isRecommendedCategory,
                                          formatCategoryName,
                                          mostPlayedGame,
                                          refs: { layerRef },
                                          id
                                      }) => {
    const closeManagedPopup = useOnClose();
    const { isPortrait } = useDeviceSelector(pick(['isPortrait']));
    const t = useTranslations();
    const username = useUserSelector(path(['userDetails', 'firstName']));
    const categoryName = isRecommendedCategory ? `${t(displayName)}, ${username}` : formatCategoryName;
    const animatedClose = useCallback((animate = true, closeLayer = true) => {
        if (layerRef.current && animate) {
            if (closeLayer) {
                layerRef.current.addEventListener('animationend', closeManagedPopup);
                layerRef.current.classList.add(style.hideLayer);
            } else {
                setTimeout(closeManagedPopup, ANIMATION_DURATION);
            }
        } else {
            setTimeout(closeManagedPopup, ANIMATION_DURATION);
        }

    }, [layerRef, closeManagedPopup]);

    useEffect(() => {
        window.addEventListener('popstate', closeManagedPopup);
        return () => {
            window.removeEventListener('popstate', closeManagedPopup);
        };
    }, []);

    return (
        <ManagedPopup
            id={id}
            title={categoryName}
            isModal={false}
            layerClassNames={{
                layer: isPortrait ? style.portraitLayer : style.landscapeLayer,
                layout: style.layout,
                overlay: style.opacity
            }}
            onClose={animatedClose}
            classNames={popupClassNames}
        >
            <Games
                cid={cid}
                categoryName={displayName}
                mostPlayedGame={mostPlayedGame}
                games={gameCodes} />
        </ManagedPopup>
    );
};
